var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_457_2567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_457_2567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error_2",
    d: "M32.4998 35.2003C32.7665 35.2003 32.9887 35.1114 33.1665 34.9336C33.3442 34.7558 33.4331 34.5336 33.4331 34.267V20.067C33.4331 19.8447 33.3442 19.6447 33.1665 19.467C32.9887 19.2892 32.7665 19.2003 32.4998 19.2003C32.2331 19.2003 32.0109 19.2892 31.8331 19.467C31.6554 19.6447 31.5665 19.867 31.5665 20.1336V34.3336C31.5665 34.5558 31.6554 34.7558 31.8331 34.9336C32.0109 35.1114 32.2331 35.2003 32.4998 35.2003ZM32.4998 43.467C32.8998 43.467 33.2225 43.3336 33.4678 43.067C33.7114 42.8003 33.8331 42.4892 33.8331 42.1336C33.8331 41.7336 33.7114 41.4118 33.4678 41.1683C33.2225 40.923 32.8998 40.8003 32.4998 40.8003C32.1442 40.8003 31.8331 40.923 31.5665 41.1683C31.2998 41.4118 31.1665 41.7336 31.1665 42.1336C31.1665 42.4892 31.2998 42.8003 31.5665 43.067C31.8331 43.3336 32.1442 43.467 32.4998 43.467ZM32.4998 55.2003C29.2554 55.2003 26.2225 54.6003 23.4011 53.4003C20.578 52.2003 18.122 50.5558 16.0331 48.467C13.9442 46.3781 12.2998 43.9221 11.0998 41.099C9.8998 38.2776 9.2998 35.2447 9.2998 32.0003C9.2998 28.7558 9.8998 25.7221 11.0998 22.899C12.2998 20.0776 13.9442 17.6225 16.0331 15.5336C18.122 13.4447 20.578 11.8003 23.4011 10.6003C26.2225 9.40029 29.2554 8.80029 32.4998 8.80029C35.7442 8.80029 38.778 9.40029 41.6011 10.6003C44.4225 11.8003 46.8776 13.4447 48.9665 15.5336C51.0554 17.6225 52.6998 20.0776 53.8998 22.899C55.0998 25.7221 55.6998 28.7558 55.6998 32.0003C55.6998 35.2447 55.0998 38.2776 53.8998 41.099C52.6998 43.9221 51.0554 46.3781 48.9665 48.467C46.8776 50.5558 44.4225 52.2003 41.6011 53.4003C38.778 54.6003 35.7442 55.2003 32.4998 55.2003ZM32.4998 53.3336C38.4109 53.3336 43.4447 51.2563 47.6011 47.1016C51.7558 42.9452 53.8331 37.9114 53.8331 32.0003C53.8331 26.0892 51.7558 21.0554 47.6011 16.899C43.4447 12.7443 38.4109 10.667 32.4998 10.667C26.5887 10.667 21.5558 12.7443 17.4011 16.899C13.2447 21.0554 11.1665 26.0892 11.1665 32.0003C11.1665 37.9114 13.2447 42.9452 17.4011 47.1016C21.5558 51.2563 26.5887 53.3336 32.4998 53.3336Z",
    fill: "#FF0000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCard);
export default __webpack_public_path__ + "static/media/error_card.9e6248d03106e4c372cbbff43a5f4440.svg";
export { ForwardRef as ReactComponent };